module.exports = __webpack_public_path__ + "static/media/book3.86863348.png";